import { QUESTION_TIME_SEC } from '../ads/adConfig.js';

// Original, informative content shown below the quiz. Written to add genuine
// value (how the game works, tips, FAQ) — no keyword stuffing, no misleading
// claims, and a clear "virtual coins" disclaimer — to stay AdSense-compliant.
export default function QuizContent({ category }) {
  const title = category ? category.title : 'QuizzyLoot';

  return (
    <section className="mx-auto max-w-3xl px-1 mt-12 text-slate-700">
      <article className="prose-quiz space-y-6">
        <div>
          <h2 className="text-2xl font-black text-slate-900">
            How to Play the {title} Quiz
          </h2>
          <p className="mt-3 leading-relaxed">
            Each round of the {title} quiz gives you a short set of
            multiple-choice questions. Read the question, weigh the options, and
            tap your answer before the {QUESTION_TIME_SEC}-second timer runs out.
            Every correct answer adds coins to your balance, and you can keep
            playing as many rounds as you like — it’s completely free.
          </p>
          <p className="mt-3 leading-relaxed">
            Not sure about a question? Use a <strong>Hint</strong> to remove one
            wrong option, or double a reward by watching a short video. These are
            optional — you can finish any quiz without them.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-black text-slate-900">Tips to score higher</h3>
          <ul className="mt-3 space-y-2 list-disc pl-5 leading-relaxed">
            <li>Read every option before you choose — the obvious answer isn’t always right.</li>
            <li>Keep an eye on the timer; a quick, confident answer beats overthinking.</li>
            <li>Save your hints for the questions you’re genuinely unsure about.</li>
            <li>Play a category you enjoy — you’ll remember more and have more fun.</li>
            <li>Come back later: questions rotate, so the same quiz stays fresh.</li>
          </ul>
        </div>

        <div>
          <h3 className="text-xl font-black text-slate-900">Frequently asked questions</h3>
          <dl className="mt-3 space-y-4">
            <div>
              <dt className="font-bold text-slate-900">Is QuizzyLoot free to play?</dt>
              <dd className="mt-1 leading-relaxed">
                Yes. Every quiz is free, and you can play as often as you like.
              </dd>
            </div>
            <div>
              <dt className="font-bold text-slate-900">Are coins real money?</dt>
              <dd className="mt-1 leading-relaxed">
                No. Coins are a virtual, in-game score with no real-world cash
                value. They can’t be exchanged for money or prizes — QuizzyLoot is
                a free trivia game made for fun and practice, not a contest,
                lottery, or gambling service.
              </dd>
            </div>
            <div>
              <dt className="font-bold text-slate-900">Do I need an account?</dt>
              <dd className="mt-1 leading-relaxed">
                No sign-up is required. Your coin balance is saved on your own
                device so you can pick up where you left off.
              </dd>
            </div>
          </dl>
        </div>

        <p className="text-xs text-slate-400 leading-relaxed">
          QuizzyLoot is an entertainment trivia game. Coins have no monetary
          value and cannot be redeemed for cash or prizes.
        </p>
      </article>
    </section>
  );
}
